module.exports = __webpack_public_path__ + "24c23e1b6319c2e738343eb2baa19551.pdf";